import React, { useEffect, useState } from "react";
import Page from "./page";
import { obtenerGerencia, obtenerResponsables, actualizarGerencia } from "../requestGerencia";
import { useHistory, useParams } from "react-router-dom";
import { object, string } from "yup";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

function Index(props) {
	const [Gerencia, SetGerencia] = useState();
	const [Responsables, SetResponsables] = useState();

	const { id: gerenciaID } = useParams();
	const history = useHistory();
	const notistack = useSnackbar();

	useEffect(() => {
		Promise.all([obtenerGerencia(gerenciaID), obtenerResponsables()])
			.then(responses => {
				SetGerencia(responses[0]);
				SetResponsables(responses[1]);
			})
			.catch(error => {
				console.error(error);
				SetGerencia({});
				SetResponsables([]);
			});
	}, []);

	/**
	 * Valores iniciales del formulario.
	 */
	const initials = {
		_id: Gerencia ? Gerencia._id : "",
		nombre: Gerencia ? Gerencia.nombre : "",
		sigla: Gerencia ? Gerencia.sigla : "",
		responsable_ref: Gerencia && Gerencia.responsable_ref ? Gerencia.responsable_ref._id : "",
	}

	/**
	 * Esquema de validación para la gerencia.
	 */
	const validation = object().shape({
		nombre: string()
			.min(3, "El nombre debe tener al menos ${min} caracteres.")
			.max(25, "El nombre debe tener a lo más ${max} caracteres.")
			.required("El nombre es requerido."),
		sigla: string()
			.min(3, "La sigla debe tener al menos ${min} caracteres.")
			.max(15, "La sigla debe tener a lo más ${max} caracteres.")
			.required("La sigla es requerida."),
		responsable_ref: string()
			.required("El responsable es requerido."),
	});

	/**
	 * Configuración de Formik Hook.
	 */
	const formik = useFormik({
		initialValues: initials,
		validationSchema: validation,
		enableReinitialize: true,
		onSubmit: (values, helper) => handleActualizar(values),
	});

	/**
	 * Handler para actualizar gerencia.
	 */
	const handleActualizar = (values) => {
		actualizarGerencia(values)
			.then(response => {
				console.log("Gerencia actualizada exitosamente.", response);
				let mensajeExito = notistack.enqueueSnackbar("Gerencia actualizada exitosamente.", {
					variant: "success",
					anchorOrigin: { vertical: "bottom", horizontal: "center" },
					action: <IconButton onClick={() => notistack.closeSnackbar(mensajeExito)}><Close /></IconButton>
				});
			})
			.catch(error => {
				console.error("Error al intentar actualizar la gerencia.", error);
				let mensajeError = notistack.enqueueSnackbar("Error al intentar actualizar la gerencia.", {
					variant: "error",
					anchorOrigin: { vertical: "bottom", horizontal: "center" },
					action: <IconButton onClick={() => notistack.closeSnackbar(mensajeError)}><Close /></IconButton>
				});
			})
			.finally(() => {
				history.push("/gerencias");
			});
	}

	/**
	 * Handler para salir del formulario.
	 */
	const handleSalir = () => {
		history.push("/gerencias");
	}

	return (
		<Page
			responsables={Responsables}
			handle_salir={handleSalir}
			formik={formik}
		/>
	);
}

export default Index;